import gql from 'graphql-tag';

export const GET_STRIPE_SUBSCRIPTIONS_QUERY = gql`
  query getStripeSubscriptions {
    stripeSubscriptions {
      id
      periodEnd
      periodStart
      status
    }
  }
`;

export const UPDATE_SUBSCRIPTION_CANCEL_REASONS_MUTATION = gql`
  mutation updateSubscription($input: UpdateSubscriptionInput!) {
    updateSubscription(input: $input) {
      errors {
        message
        type
      }
      subscription {
        cancelReasons
      }
    }
  }
`;

export const CANCEL_SUBSCRIPTION_MUTATION = gql`
  mutation cancelSubscription($input: CancelSubscriptionInput!) {
    cancelSubscription(input: $input) {
      errors {
        message
        type
      }
      subscription {
        cancelled
      }
    }
  }
`;

export const PAUSE_SUBSCRIPTION_MUTATION = gql`
  mutation pauseSubscription($input: PauseSubscriptionInput!) {
    pauseSubscription(input: $input) {
      errors {
        message
        type
      }
    }
  }
`;

export const CREATE_LITE_STRIPE_CHECKOUT_SESSION_MUTATION = gql`
  mutation CreateLiteStripeCheckoutSession($input: CreateLiteStripeCheckoutSessionInput!) {
    createLiteStripeCheckoutSession(input: $input) {
      sessionId
      url
      errors {
        message
      }
    }
  }
`;

export const UNPAUSE_SUBSCRIPTION_MUTATION = gql`
  mutation unpauseSubscription($input: UnpauseSubscriptionInput!) {
    unpauseSubscription(input: $input) {
      errors {
        message
        type
      }
    }
  }
`;

export const CHANGE_STRIPE_SUBSCRIPTION_MUTATION = gql`
  mutation changeStripeSubscription($input: ChangeStripeSubscriptionInput!) {
    changeStripeSubscription(input: $input) {
      # Assuming it might return errors, adjust if needed based on actual backend
      errors {
        message
        type
      }
      # Optionally return subscription details if the backend provides them
      # subscription {
      #   id
      #   plan
      #   period
      # }
    }
  }
`;
